// Cart Drawer Fix - Add fallback timeout to remove is-closing class
document.addEventListener('DOMContentLoaded', function() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;

  // Override the closeCartDrawer method to add a fallback timeout
  const originalCloseCartDrawer = cartDrawer.closeCartDrawer;
  if (originalCloseCartDrawer) {
    cartDrawer.closeCartDrawer = function() {
      if (!this.classList.contains('is-open')) return;

      this.classList.add('is-closing');
      this.classList.remove('is-open');

      this.cartDrawerIsOpen = false;

      document.dispatchEvent(
        new CustomEvent('theme:cart-drawer:close', {
          bubbles: true,
        })
      );

      this.a11y.removeTrapFocus();
      this.a11y.autoFocusLastElement();

      document.body.removeEventListener('click', this.onBodyClickEvent);
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

      // Add fallback timeout to ensure is-closing class is removed
      const fallbackTimeout = setTimeout(() => {
        this.classList.remove('is-closing');
      }, 700); // Slightly longer than animation duration (0.6s)

      // Try to wait for animation end, but clear timeout if it works
      window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
        clearTimeout(fallbackTimeout);
        this.classList.remove('is-closing');
      }).catch(() => {
        // If waitForAnimationEnd fails, the timeout will handle cleanup
        console.log('Animation end event failed, using fallback timeout');
      });
    };
  }
}); 